"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorDebugStore = void 0;
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var scroll_into_view_if_needed_1 = __importDefault(require("scroll-into-view-if-needed"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var ActionType;
(function (ActionType) {
    ActionType["InspectNode"] = "inspect_node";
    ActionType["RegisterListener"] = "register_listener";
    ActionType["ScrollNode"] = "scroll_node";
})(ActionType || (ActionType = {}));
var EditorDebugStore = (function () {
    function EditorDebugStore() {
        var _this = this;
        this.EDITOR_DEBUG_VERSION = "2.0.0";
        this.editors = new Set();
        this.debugOverlayState = undefined;
        this.registerEditor = function (editor) {
            _this.editors.add(editor);
            _this.onEditorChange();
        };
        this.unregisterEditor = function (editor) {
            _this.editors.delete(editor);
            _this.onEditorChange();
        };
        this.handleEditorDebugHookCall = function (action) {
            switch (action.type) {
                case ActionType.InspectNode: {
                    _this.handleInspectNode(action);
                    break;
                }
                case ActionType.RegisterListener: {
                    _this.registerChangeListener(action.listener);
                    break;
                }
                case ActionType.ScrollNode: {
                    _this.handleScrollNode(action);
                }
            }
        };
        this.registerChangeListener = function (listener) {
            _this.editorDebugListener = listener;
            _this.onEditorChange();
        };
        this.handleInspectNode = function (_a) {
            var _b;
            var path = _a.path, editorId = _a.editorId, toggle = _a.toggle;
            var editor = _this.getEditor(editorId);
            if (!editor) {
                return;
            }
            var node = slate_react_1.ReactEditor.toDOMNode(editor, slate_1.Editor.node(editor, path)[0]);
            if (toggle === "off") {
                _this.debugOverlayState = undefined;
                (_b = _this.debugOverlayRectObserver) === null || _b === void 0 ? void 0 : _b.unobserve();
                _this.debugOverlayRectObserver = undefined;
            }
            else {
                var updateRect = (0, mobx_1.action)(function (rect) {
                    _this.debugOverlayState = {
                        editorId: editorId,
                        overlayProps: {
                            width: "".concat(rect.width || 1, "px"),
                            height: "".concat(rect.height || 1, "px"),
                            top: "".concat(rect.top, "px"),
                            left: "".concat(rect.left, "px"),
                        },
                    };
                });
                var rectObserver = (0, observe_rect_1.default)(node, updateRect);
                rectObserver.observe();
                _this.debugOverlayRectObserver = rectObserver;
                updateRect(node.getBoundingClientRect());
            }
        };
        this.handleScrollNode = function (_a) {
            var path = _a.path, editorId = _a.editorId;
            var editor = _this.getEditor(editorId);
            if (!editor) {
                return;
            }
            var node = slate_react_1.ReactEditor.toDOMNode(editor, slate_1.Editor.node(editor, path)[0]);
            (0, scroll_into_view_if_needed_1.default)(node, { scrollMode: "if-needed", behavior: "smooth", block: "center" });
        };
        this.getEditor = function (editorId) {
            var editor = Array.from(_this.editors.values()).find(function (f) { return f.uniqueId === editorId; });
            return editor;
        };
        window.__QWILR_EDITOR_DEBUG_HOOK__ = this.handleEditorDebugHookCall;
        window.__QWILR_EDITOR_DEBUG_VERSION__ = this.EDITOR_DEBUG_VERSION;
    }
    EditorDebugStore.prototype.onEditorChange = function () {
        if (!this.editorDebugListener) {
            return;
        }
        var editorDebug = this.editorDebugData;
        try {
            this.editorDebugListener(editorDebug);
        }
        catch (e) {
            console.log("Error while broadcasting editor change to debugger extension: ".concat(e));
        }
    };
    Object.defineProperty(EditorDebugStore.prototype, "editorDebugData", {
        get: function () {
            return Array.from(this.editors.values()).map(function (editor) {
                return {
                    id: editor.uniqueId,
                    children: editor.children.map(decorateChildWithDebug),
                    selection: (0, lodash_1.cloneDeep)(editor.selection),
                    schemaName: editor.schema.name,
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], EditorDebugStore.prototype, "debugOverlayState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EditorDebugStore.prototype, "handleInspectNode", void 0);
    return EditorDebugStore;
}());
exports.EditorDebugStore = EditorDebugStore;
var decorateChildWithDebug = function (node) {
    var clonedChild = (0, lodash_1.cloneDeep)(node);
    if (slate_1.Element.isElement(clonedChild)) {
        clonedChild.displayType = "Slate node (".concat(node.type, ")");
        clonedChild.children = clonedChild.children.map(decorateChildWithDebug);
    }
    if (slate_1.Text.isText(clonedChild)) {
        clonedChild.displayType = "Slate node (text)";
    }
    return clonedChild;
};
